export default "__VITE_ASSET__DBpxMjXx__"